import { combineReducers } from "redux";
import authenticationReducer from "./authenticationReducer";
import sidebarReducer from './sidebarReducer';
import betslipReducer from './betslipReducer';


const rootReducer = combineReducers({
  auth: authenticationReducer,
  sidebar: sidebarReducer,
  betslip : betslipReducer
});

export default rootReducer;
